import { ClientOnly } from "zudoku/components";
import { useTheme } from "zudoku/hooks";
import { APP_ORIGIN } from "../lib/localization";
import { LocaleSelector } from "./locale-selector";
import { useDocsLocalization } from "./use-docs-localization";

const moonIcon = (
  <svg aria-hidden="true" viewBox="0 0 24 24">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />
  </svg>
);

function CompactThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const { messages } = useDocsLocalization();
  const isDark = resolvedTheme === "dark";

  return (
    <button
      aria-label={messages.toggleColorTheme}
      aria-pressed={isDark}
      className="kaleo-compact-theme-toggle"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      type="button"
    >
      <ClientOnly fallback={moonIcon}>
        {isDark ? (
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41" />
          </svg>
        ) : (
          moonIcon
        )}
      </ClientOnly>
    </button>
  );
}

export function DocsHeaderActions({
  compact = false,
}: {
  compact?: boolean;
}) {
  const { messages } = useDocsLocalization();

  return (
    <div
      className={`kaleo-docs-header-actions${compact ? " kaleo-docs-header-actions-compact" : ""}`}
      data-pagefind-ignore="all"
    >
      <LocaleSelector compact={compact} />
      {compact ? (
        <CompactThemeToggle />
      ) : (
        <a
          className="kaleo-header-action kaleo-header-dashboard"
          href={APP_ORIGIN}
          rel="noopener noreferrer"
          target="_blank"
        >
          {messages.dashboard}
        </a>
      )}
    </div>
  );
}
